<template>
  <div id="app">
    <search-bar ref="searchBarComponent">
     <!-- <div slot="search-tool">
        <el-button class="item-btn el-icon-plus" type="primary" @click="addCard">添加车辆</el-button>
      </div> -->
      <div slot="search-cont">

        <div class="item">
          <div class="item-label">车辆名称搜索</div>
          <div style="width: 300px;">
            <el-input placeholder="请输入内容" v-model="info.car_name" class="input-with-select" size="small" @keyup.enter.native='searchResume'></el-input>
          </div>
        </div>

        <div class="item" >
          <div class="item-label">车牌号搜索</div>
          <div style="width: 300px;">
            <el-input placeholder="请输入内容" v-model="info.car_number" class="input-with-select" size="small" @keyup.enter.native='searchResume'></el-input>
          </div>
        </div>
        <!--  操作按钮 start -->
          <div class="item">
            <el-button class="item-btn" type="primary" @click="searchResume">查询</el-button>

          </div>
        <!--  操作按钮 end -->

      </div>
    </search-bar>

    <div class="operation-tool">
      <div @click="addCard()" class="tool-item"> <img src="../../../static/img/btn/add.png" /> 添加车辆</div>
    </div>

    <div class="l-panel">
       <div class="panel-body">
      <el-table class="l-table" stripe :data="tableData" style="width: 100%;">
        <el-table-column prop="car_name" label="车辆名称" align="left" ></el-table-column>
        <el-table-column prop="car_number" label="车牌号" align="left" ></el-table-column>
        <el-table-column prop="amount" label="座位数" align="left"></el-table-column>


        <el-table-column prop="amount" label="操作" width="280">
          <template slot-scope='{row}'>
              <el-button type="warning" size="mini" @click='deleteCar(row)'>删除</el-button>

          </template>
        </el-table-column>
      </el-table>
      <div class="c-table-pager">
        <el-pagination  :total="total" @current-change='paginationChange'> </el-pagination>
      </div>
      </div>
    </div>


    <el-dialog title="添加车辆" :visible.sync="dialogVisible" width="500px">
      <div class="dialogContent">
        <el-form :model="basic" ref="basic" label-width="100px" class="demo-ruleForm" :rules="rules">
          <el-form-item label="车辆名称" prop="car_name">
              <el-input v-model="basic.car_name" placeholder="请输入车辆名称"></el-input>
          </el-form-item>
          <el-form-item label="车牌号"  prop="car_number">
              <el-input v-model="basic.car_number" placeholder="请输入车牌号"></el-input>
          </el-form-item>
          <el-form-item label="座位数"  prop="amount">
              <el-input v-model="basic.amount" type="number" placeholder="请输入座位数"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('basic')">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="更新保险" :visible.sync="dialogVisibleInsure" width="500px">
      <div class="dialogContent">
        <el-form :model="insureForm" ref="insureForm" label-width="120px" label-position="left" class="demo-ruleForm" :rules="insureFormRules">

          <el-form-item label="车牌号" >
              <el-input v-model="insureForm.car_number" disabled placeholder="请输入车牌号"></el-input>
          </el-form-item>
          <el-form-item label="保险生效日期"  prop="insureBuyTime">
            <el-date-picker style="width: 100%;"
                  v-model="insureForm.insureBuyTime"
                  type="date"
                  placeholder="选择日期">
                </el-date-picker>

          </el-form-item>
          <el-form-item label="保险过期日期" prop="insureEndTime">
              <el-date-picker style="width: 100%;"
                    v-model="insureForm.insureEndTime"
                    type="date"
                    placeholder="选择日期">
                  </el-date-picker>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleInsure = false">取 消</el-button>
        <el-button type="primary" @click="submitInsureForm('insureForm')">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog :title="dialogVisibleReminderTitle" :visible.sync="dialogVisibleReminder" width="500px">
      <div class="dialogContent">
        <el-form :model="reminderForm" ref="reminderForm" label-width="120px" label-position="left" class="demo-ruleForm" :rules="reminderFormRules">

          <el-form-item label="车牌号" >
              <el-input v-model="reminderForm.car_number" disabled placeholder="请输入车牌号"></el-input>
          </el-form-item>

          <el-form-item label="保险通知人" prop="utypeid">
              <el-select v-model="reminderForm.utypeid" placeholder="请选择">
                  <el-option
                    v-for="item in personOptions"
                    :key="item.id"
                    :label="item.oausername"
                    :value="item.id">
                  </el-option>
                </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleReminder = false">取 消</el-button>
        <el-button type="primary" @click="submitReminderForm('reminderForm')">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
  import Message from '@/utils/message.js';
  export default {
    data() {
      return {
        info: {
          page: 1,
          key:'',
          begintimes:[],
          begintime:'',
          endtime:'',
          key_type:''

        },
        total: 1,
        tableData:[],
        dialogVisible:false,
        basic:{
            car_name:'',
            car_number:'',
            amount:''
        },
        rules:{
           car_name: [ { required: true, message: '请输入车辆名称', trigger: 'blur' },],
           car_number: [ { required: true, message: '请输入车牌号码', trigger: 'blur' },],
           amount: [ { required: true, message: '请输入座位数', trigger: 'blur' },],
        },
        dialogVisibleInsure:false,//更新保险弹窗
        insureForm:{
          car_id:"",
          car_number:"",
          insureBuyTime:"",
          insureEndTime:""
        },
        insureFormRules:{
           insureBuyTime: [ { required: true, message: '保险生效日期', trigger: 'change' },],
           insureEndTime: [ { required: true, message: '保险过期日期', trigger: 'change' },],
        },
        dialogVisibleReminder:false,//通知人弹窗
        dialogVisibleReminderTitle:"添加通知人",
        reminderForm:{
          car_id:"",
          car_number:"",
          utypeid:"",
          usernname:"",
        },
        reminderFormRules:{
           utypeid: [ { required: true, message: '请选择', trigger: 'change' },],
        },
        personOptions:[]

      }
    },

    created() {
          this.$nextTick(() => {
            document.onselectstart = new Function("event.returnValue=true");
          });
    },

    mounted() {
      this.queryInfo()
      this.getPerson()
    },
    methods: {

      deleteCar(row){
        this.$confirm('此操作将删除此条数据, 是否继续?', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(() => {
                 this.gets('setting/delCar',{id:row.id}).then((res)=>{
                   this.queryInfo()
                   res.data.code == 1?Message.success(res.data.msg):Message.warning(res.data.msg)
                 })
                }).catch(() => {});

      },

        submitForm(formName) {
              this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.gets('setting/addCar',this.basic).then(res=>{
                      res.data.code == 1?Message.success(res.data.msg):Message.warning(res.data.msg)
                      if(res.data.code == 1) {
                        this.queryInfo()
                        this.dialogVisible = false
                      }
                  
                    })
                } else {
                 return console.log('error submit!!');
                }
              });
            },

      addCard(){
        this.basic.amount = ''
        this.basic.car_name = ''
        this.basic.car_number = ''
        this.dialogVisible = true
      },

      paginationChange(val) {
        this.info.page = val
        this.queryInfo()
      },

      interviewTimeChange(val) {
        this.info.begintime = val[0]
        this.info.endtime = val[1]
        this.info.page = 1
        this.queryInfo()
      },

      searchResume() {
        this.info.page = 1
        this.queryInfo()
      },

      queryInfo() {
        this.gets('setting/getCarList', this.info).then(res => {
          this.tableData = res.data.data.list
          this.total = res.data.data.pagination.total
        })
      },
      //车辆保险 - 确认收到通知
      confirmReceiveSms(id='') {
        let param = {car_id:id}
        this.post('setting/confirmCarInsureRemind', param).then(res => {
          res.data.code == 1?Message.success(res.data.msg):Message.warning(res.data.msg)
          this.queryInfo()
        })
      },

      onOpenInsureDialog(row) {
        this.clearInsureForm()
        this.insureForm.car_id = row.id;
        this.insureForm.car_number = row.car_number
        this.insureForm.insureBuyTime = row.insureBuyTime
        this.insureForm.insureEndTime = row.insureEndTime
        this.dialogVisibleInsure = true
      },
      clearInsureForm() {
        for(let key in this.insureForm) {
          this.insureForm[key] = ''
        }
      },
      //更新保险
      submitInsureForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {

              this.post('setting/editInsureCar',this.insureForm).then(res=>{
                res.data.code == 1?Message.success(res.data.msg):Message.warning(res.data.msg)
                this.queryInfo()
                this.dialogVisibleInsure = false
              })
          } else {
           return console.log('error submit!!');
          }
        });
      },
      getPerson() {
        this.gets('oasystem/cateadminlist',{agenttype:1}).then(res=>{
          this.personOptions = res.data.data
        })
      },
      onOpenReminderDialog(row) {
        this.clearReminderForm()

        this.reminderForm.car_id = row.id;
        this.reminderForm.car_number = row.car_number
        this.reminderForm.utypeid = row.remind_utypeid

        this.dialogVisibleReminder = true
      },
      clearReminderForm() {
        for(let key in this.reminderForm) {
          this.reminderForm[key] = ''
        }
      },
      submitReminderForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {

              this.post('setting/addCarInsureReminder',this.reminderForm).then(res=>{
                res.data.code == 1?Message.success(res.data.msg):Message.warning(res.data.msg)
                this.queryInfo()
                this.dialogVisibleReminder = false
              })
          } else {
           return console.log('error submit!!');
          }
        });
      }

    },

  }
</script>

<style scoped>
  .table {
    margin: 30px 0;
    padding: 20px;
    background: #fff;
  }

  .pagination {
    text-align: center;
    width: 100%;
    background: #fff;
    height: 50px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .totalNumber {
    height: 50px;
    padding: 0 20px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
  }
</style>



// WEBPACK FOOTER //
// src/view/system/driveCarList.vue